const about = {
  "name": "Sergio W. Peterson",
  "location": "San Francisco, CA",
  "title": "AI Engineer | Agent Intelligence",
  "short": "AI engineer at Sauna by Wordware (YC S24) - agents, ML, and full-stack systems.",
  "bio": [
    "UC Berkeley graduate with a B.A. in Data Science focused on robotics and software engineering.",
    "I specialize in building full-stack systems and AI pipelines from scratch, with a focus on machine learning, robotics, and large-scale infrastructure around LLMs, computer vision, and autonomous systems.",
    "Currently an AI Engineer on the Agent Intelligence team at Sauna by Wordware (YC S24), teaching Sauna to think, remember, and act on your behalf. Previously the founding engineer and first hire at Minerva Intelligence (YCX25)."
  ],
  "hobbies": [
    "Collegiate Archery Team",
    "Guitar",
    "Weightlifting"
  ],
  "quote": "\"You can lose 100 10,000 times. All you need to do is win once.\" - Sergio W. Peterson",
  "contact": {
    "email": "sergiopeterson.dev@gmail.com",
    "github": "https://github.com/SergioPeterson",
    "linkedin": "https://www.linkedin.com/in/sergio-w-peterson/",
    "twitter": "https://x.com/sergiopeter4",
    "instagram": "https://www.instagram.com/sergiopeter2020/"
  },
  "techStack": [
    "Python",
    "C++",
    "JavaScript",
    "TypeScript",
    "React",
    "Cloudflare Workers",
    "Node.js",
    "PyTorch",
    "TensorFlow",
    "OpenCV",
    "YOLO",
    "PostgreSQL",
    "Redis",
    "MongoDB",
    "AWS",
    "Docker",
    "Kubernetes",
    "GitHub Actions",
    "ROS"
  ],
  "recruiter": {
    "intro": "Fast path for recruiters and hiring managers.",
    "quickStart": [],
    "featuredProjects": [
      "corgi-insurance-claims-classifier",
      "movie-recommendation-system",
      "voidformer"
    ]
  }
};

export default about;
